export type ToastTone = "success" | "info" | "loading";

export interface ToastRecord {
  id: string;
  tone: ToastTone;
  title: string;
  durationMs: number | null;
}

export type ToastState = ToastRecord[];

export type ToastInput = {
  id?: string;
  tone: ToastTone;
  title: string;
  durationMs?: number | null;
};

type ToastAction =
  | { type: "create"; toast: ToastRecord }
  | { type: "update"; id: string; patch: ToastInput }
  | { type: "dismiss"; id: string };

export function createToast(input: ToastInput): ToastAction {
  return {
    type: "create",
    toast: normalizeToast(input)
  };
}

export function updateToast(id: string, patch: ToastInput): ToastAction {
  return {
    type: "update",
    id,
    patch
  };
}

export function dismissToast(id: string): ToastAction {
  return {
    type: "dismiss",
    id
  };
}

export function toastsReducer(state: ToastState, action: ToastAction): ToastState {
  if (action.type === "create") {
    return [action.toast, ...state.filter((toast) => toast.id !== action.toast.id)];
  }

  if (action.type === "update") {
    return state.map((toast) => (
      toast.id === action.id
        ? normalizeToast({
          ...toast,
          ...action.patch,
          id: toast.id,
          durationMs: action.patch.durationMs
        })
        : toast
    ));
  }

  return state.filter((toast) => toast.id !== action.id);
}

function normalizeToast(input: ToastInput): ToastRecord {
  return {
    id: input.id ?? crypto.randomUUID(),
    tone: input.tone,
    title: input.title,
    durationMs: input.durationMs === undefined ? defaultDurationMs(input.tone) : input.durationMs
  };
}

function defaultDurationMs(tone: ToastTone): number | null {
  if (tone === "loading") return null;
  if (tone === "success") return 2500;
  return 3000;
}
